<script>
    const coefficients = [0.04, 0.01, 0.63]

    const firstJanuary = new Date('2023-01-01').valueOf() / 1000
    const now = new Date().valueOf() / 1000
    const diff = now - firstJanuary

    // 0: co2
    // 1: automovil
    // 2: arboles
    let totals = [0, 0, 0]

    // valores iniciales
    for (let i = 0; i < totals.length; i++) {
        totals[i] += coefficients[i] * diff
    }

    setInterval(() => {
        for (let i = 0; i < totals.length; i++) {
            totals[i] += coefficients[i]
        }
    }, 1000)
</script>

<main>
    <article>
        Traemos progreso a la vida a través de acciones concretas que evitan la emisión de Gases de Efecto Invernadero
        (CO<sub><small>2</small></sub>) en la producción de proteína animal.
    </article>
    <!-- <img class="globe" src="assets/imgs/globe.png" alt="globo terraqueo" /> -->
    <div class="globe" />
    <section class="co2-section">
        <article>
            En 2023 ya hemos alcanzado una <b>reducción de emisiones de CO<sub><small>2</small></sub> de:</b>
        </article>
        <article class="indicator">
            <img
                class="globe-termomether"
                src="assets/imgs/temperature.png"
                width="160"
                alt="icono de globo terraqueo con un termometro"
            />
            <div>
                {totals[0].toLocaleString('es', { maximumFractionDigits: 1, minimumFractionDigits: 1 })}
                <span>
                    tn CO
                    <span class="align-sub"><sub><small>2</small></sub></span>eq.
                </span>
            </div>
        </article>
    </section>
    <section>
        <article class="article-small">Esta reducción es equivalente a:</article>
        <div class="d-flex">
            <img class="bar" src="assets/imgs/bar.png" height="240" alt="barra vertical" />
            <section class="indicator-container">
                <div class="indicator-item">
                    <div class="number-small number-plant">
                        <div>
                            {totals[2].toLocaleString('es', { maximumFractionDigits: 1, minimumFractionDigits: 1 })}
                        </div>
                    </div>
                    <div class="indicator-tres">
                        <div class="indicator-dos">
                            <div class="indicator-title">Árboles</div>
                            <img
                                src="assets/imgs/hand.png"
                                height="90"
                                alt="icono una planta creciendo de la palma de una mano"
                            />
                        </div>
                        <div class="indicator-caption indicator-caption-plant">cultivados durante 10 años</div>
                    </div>
                </div>
                <div class="indicator-item">
                    <div class="number-small number-plant">
                        <div>
                            {totals[1].toLocaleString('es', { maximumFractionDigits: 1, minimumFractionDigits: 1 })}
                        </div>
                    </div>
                    <div class="indicator-tres">
                        <div class="indicator-dos">
                            <div class="indicator-title">Vehículos</div>
                            <img
                                class="vehicle"
                                src="assets/imgs/vehicle.png"
                                height="70"
                                alt="icono de un automovil con el icono de reciclado en el centro"
                            />
                        </div>
                        <div class="indicator-caption">que no fueron conducidos al año</div>
                    </div>
                </div>
            </section>
        </div>
    </section>
</main>

<style>
    .number-small {
        font-size: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .globe-termomether {
        margin-left: -30px;
    }

    .align-sub {
        margin-left: -15px;
    }

    .d-flex {
        display: flex;
    }

    .co2-section {
        display: flex;
        flex-direction: column;
        gap: 30px;
    }

    .number-plant {
        min-width: 180px;
    }
    .bar {
        padding-top: 30px;
        margin-left: -30px;
    }
    .vehicle {
        padding-top: 20px;
    }
    sub {
        vertical-align: baseline;
        position: relative;
        top: -0.4em;
    }
    sub {
        top: 0.4em;
    }

    .indicator-title {
        font-size: 40px;
        font-style: italic;
        font-weight: bold;
    }

    .indicator-caption-plant {
        padding-right: 65px;
    }

    .indicator-caption {
        font-size: 28px;
        font-style: italic;
    }

    .indicator {
        display: flex;
        align-items: center;
        font-size: 46px;
        justify-content: space-between;
        padding-right: 20%;
    }

    .indicator-container {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .indicator-item {
        display: flex;
        gap: 20px;
        align-items: center;
        justify-content: start;
    }
    .indicator-tres {
        display: flex;
        flex-direction: column;
    }

    .indicator-dos {
        display: flex;
        align-items: end;
        justify-content: space-between;
        gap: 20px;
    }

    small {
        font-size: 22px;
    }

    main article {
        font-size: 32px;
        letter-spacing: 0.116rem;
        line-height: 2.5rem;
    }

    main article.article-small {
        font-size: 28px;
    }

    .globe {
        background-image: url('imgs/globe.png');
        justify-self: center;
        align-self: center;
        background-size: cover;
        width: 491px;
        height: 341px;
        /* width: 200px;
        height: 200px; */
        /* box-shadow: 0 0 8px 8px #111e31 inset; */
        mask-image: linear-gradient(to top, black 0%, black 100%), linear-gradient(to top, transparent 0%, black 100%),
            linear-gradient(to right, transparent 0%, black 100%),
            linear-gradient(to bottom, transparent 0%, black 100%), linear-gradient(to left, transparent 0%, black 100%);
        mask-position: center, top, right, bottom, left;
        mask-size: 100% 100%, 100% 40px, 40px 100%, 100% 40px, 40px 100%;
        mask-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
        mask-composite: subtract, add, add, add;
    }

    main {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 0.8fr 1fr;
        gap: 30px;
        padding-left: 50px;
        padding-top: 40px;
    }
</style>
